import React from 'react';
import { mockData } from '../mockData';
import { Download } from 'lucide-react';
import '../styles/AuthPages.css';

const VerifyEmailPage = () => {
  const handleDownload = (store) => {
    const url = store === 'google' ? mockData.appStoreLinks.googlePlay : mockData.appStoreLinks.appStore;
    window.open(url, '_blank');
  };

  const handleOpenApp = () => {
    window.location.href = 'marketsentinel://auth/callback';
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-content">
          <h1 className="auth-title">Email verified ✓</h1>
          <p className="auth-text">
            Your account is confirmed. Open Market Sentinel to log in.
          </p>
          
          <button className="btn-primary auth-primary-btn" onClick={handleOpenApp}>
            Open Market Sentinel
          </button>
          
          <div className="auth-fallback">
            <p className="auth-fallback-text">Don't have the app yet?</p>
            <div className="auth-store-buttons">
              <button className="btn-secondary" onClick={() => handleDownload('google')}>
                <Download size={20} />
                Google Play
              </button>
              <button className="btn-secondary" onClick={() => handleDownload('apple')}>
                <Download size={20} />
                App Store
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
